import { render, staticRenderFns } from "./BarcodeScannerInput.vue?vue&type=template&id=3a3f48c4&"
import script from "./BarcodeScannerInput.vue?vue&type=script&lang=js&"
export * from "./BarcodeScannerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports